// src/features/authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  accessToken: string | null;
  accessTokenExpiration: Date | null;
}

const initialState: AuthState = {
  accessToken: null,
  accessTokenExpiration: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessToken(state, action: PayloadAction<string | null>) {
      state.accessToken = action.payload;
    },
    setAccessTokenExpiration(state, action: PayloadAction<Date | null>) {
      state.accessTokenExpiration = action.payload;
    },
    clear(state) {
      state.accessTokenExpiration = null;
      state.accessToken = null;
    },
  },
});

export const { setAccessToken, setAccessTokenExpiration, clear } =
  authSlice.actions;
export default authSlice.reducer;
